<template>
    <component
        :is="tag"
        :to="isRouterLink ? to : null"
        :href="isAnchor ? href : null"
        :type="isNativeButton ? type : null"
        :target="isAnchor ? target : null"
        :rel="isAnchor && target === '_blank' ? 'noopener noreferrer' : null"
        :disabled="isNativeButton && disabled ? true : null"
        :aria-disabled="disabled ? 'true' : null"
        :class="classes"
        v-on="$listeners"
    >
        <slot name="icon-left" />
        <slot>{{ label }}</slot>
        <slot name="icon-right" />
    </component>
</template>

<script>
export default {
    name: 'PipButton',
    props: {
        // Visual variant: primary, secondary, dark, light, danger, success,
        // warning, outline-primary, outline-secondary, outline-dark,
        // outline-light, ghost
        variant: {
            type: String,
            default: 'primary'
        },
        // Size modifier: '', 'sm', 'lg'
        size: {
            type: String,
            default: ''
        },
        // Shape modifier
        pill: {
            type: Boolean,
            default: false
        },
        // Full-width
        block: {
            type: Boolean,
            default: false
        },
        // Convenience text prop (slot takes precedence)
        label: {
            type: String,
            default: ''
        },
        // If provided, renders a <router-link>
        to: {
            type: [String, Object],
            default: null
        },
        // If provided (and no `to`), renders an <a>
        href: {
            type: String,
            default: null
        },
        // Anchor target when using href
        target: {
            type: String,
            default: null
        },
        // Native button type
        type: {
            type: String,
            default: 'button'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isRouterLink() {
            return this.to !== null && this.to !== undefined;
        },
        isAnchor() {
            return !this.isRouterLink && !!this.href;
        },
        isNativeButton() {
            return !this.isRouterLink && !this.isAnchor;
        },
        tag() {
            if (this.isRouterLink) return 'router-link';
            if (this.isAnchor) return 'a';
            return 'button';
        },
        classes() {
            return [
                'btn',
                `btn-${this.variant}`,
                this.size ? `btn-${this.size}` : null,
                this.pill ? 'btn-pill' : null,
                this.block ? 'btn-block' : null,
                this.disabled ? 'is-disabled' : null
            ].filter(Boolean);
        }
    }
};
</script>
